import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=99541de2&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"
import style0 from "./Friends.vue?vue&type=style&index=0&id=99541de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99541de2",
  null
  
)

export default component.exports